// extracted by mini-css-extract-plugin
module.exports = {"delimiter":"Delimiter_delimiter__n1arm","white":"Delimiter_white__3OYyC","dark":"Delimiter_dark__2nVrX"};